export const NavigationPath = {
  LOGIN_ROUTE: "/login",
  RESET_PASSWORD_ROUTE: "/reset-password",
  USERS_ROUTE: "/users",
  ADD_USER_ROUTE: "/add-user",
  EDIT_USER_ROUTE: "/edit-user/:id",
  OFFER_REQUESTS_ROUTE: "/offer-requests",
  ADD_OFFER_REQUEST_ROUTE: "/add-offer-request",
  EDIT_OFFER_REQUEST_ROUTE: "/edit-offer-request/:id",
  OFFER_RESPONSES_ROUTE: "/offer-responses",
  SINGLE_OFFER_RESPONSES_ROUTE: "/offer-request/:offerRequestId/responses",
  SINGLE_RESPONSE_ROUTE: "/offer-response/:offerResponseId",
  INSURANCE_ROUTE: "/insurance",
  ADD_INSURANCE_ROUTE: "/add-insurance",
  EDIT_INSURANCE_ROUTE: "/edit-insurance/:id",
  INSURANCE_OFFER_REQUESTS_ROUTE: "/insurance-offer-requests",
  INSURANCE_OFFER_RESPONSE_ROUTE: "/insurance-offer-response/:id",
  ORDERS_ROUTE: "/orders",
};
